import * as ActionTypes from '../constants/ActionTypes';
import API from '../helpers/api';

export function getPurchaseHistory() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.GET_PURCHASE_HISTORY_PAGE_REQUEST,
			payload: { loadingTickets: true }
		});

		//Get all tickets
		const response = await API.ticket.getTickets();

		if(response.meta.code !== 200){
			dispatch({
				type: ActionTypes.GET_PURCHASE_HISTORY_PAGE_ERROR,
				payload: {
					meta: response.meta,
					loadingTickets: false
				}
			});
			return;
		}

		const { tickets } = response.data;

		dispatch({
			type: ActionTypes.GET_PURCHASE_HISTORY_PAGE_SUCCESS,
			payload: {
				tickets,
				loadingTickets: false
			}
		});
	};
}

export function resetMeta() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.RESET_PURCHASE_HISTORY_PAGE_META
		});
	};
}

export function resetPage() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.RESET_PURCHASE_HISTORY_PAGE
		});
	};
}
